module.exports = __webpack_public_path__ + "d266727dc8d9b835888d77885776d700.svg";